module.exports = __webpack_public_path__ + "assets/img/reheat.493322e9.png";